import { Base } from '@studiometa/js-toolkit';
import Title from './Title.js';
import Logo from './Logo.js';
import Fade from './Fade.js';
import CollectionHero from './CollectionHero.js';
import ProductCard from './ProductCard.js';
import Parallax from '../Sections/Parallax.js';

/**
 * Animations component
 */
export default class Animations extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Animations',
    components: {
      '[data-fade]': Fade,
      '[data-title]': Title,
      Logo,
      CollectionHero,
      ProductCard,
      Parallax,
    },
  };
}
